// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md style="margin-bottom:100px;">
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'apikeys'"
        editRoute="apikeyEdit"
        :headers="headers"
        id="_id"
        name="API Key"
        :searchBarText="searchBarText"
        permissions="apikeys"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'

import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Token',
          value: 'token',
          sortable: false
        },
        {
          text: 'Role',
          value: 'role',
          context: ENDPOINT + 'roles',
          function: this.getRoleName,
          sortable: false
        }
      ]
    }
  },

  methods: {
    getRoleName: function (item, list) {
      if (item.roles) {
        if (item.roles !== '' && list) {
          if (item.roles.length > 0) {
            var o = ''
            for (var i in item.roles) {
              var x = list.find((el) => el.id === item.roles[i])
              if (x) {
                o = o + x.name
              } else {
                o = o + 'N/A'
              }

              if (i < item.roles.length - 1) {
                o = o + ', '
              }
            }
            return o
          }
        }
      }
      return 'N/A'
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApiKeys.vue?68129dc8